/* eslint-disable max-len */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchFileBamCommercialFamilyCodesRequestSaga,
  getBamCommercialFamilyCodes,
  getBamCommercialFamilyCodesFileFetchStatus,
} from 'domains/bamCommercialFamilyCodes/BamCommercialFamilyCodes.store';

export const useFetchBamCommercialFamilyCodes = (): string[] => {
  const dispatch = useDispatch();
  const status = useSelector(getBamCommercialFamilyCodesFileFetchStatus);
  const bamCommercialFamilyCodes = useSelector(getBamCommercialFamilyCodes);

  useEffect(() => {
    if (!status) {
      dispatch(fetchFileBamCommercialFamilyCodesRequestSaga());
    }
  }, [dispatch, status]);

  return bamCommercialFamilyCodes;
};
